<template>
  <div class="o-input">
    <label class="o-input__label">{{ category.title }}</label>
    <div class="o-input__controls">
      <div class="c-shopping-list">
        <slot></slot>
        <div class="c-shopping-list__row c-shopping-list__row--summary">
          <div class="c-shopping-list__description">Subtotaal</div>
          <div class="c-shopping-list__price">{{ formatCurrency(totalCost) }} euro</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cmp from "./";

export default {
  name: "ListCategory",
  ...cmp,
};
</script>
